import React from "react";
import { useTranslation } from "react-i18next";

const ProviderStatusChanged = ({ notification }) => {
  const { t } = useTranslation();

  const benefitName = notification?.payload?.benefitName || "";

  return (
    <>
      <h4 className="notification-title">
        {t("notification_provider_status_changed_title", { benefitName })}
      </h4>
      <p className="notification-subtitle">
        {t("notification_provider_status_changed_subtitle")}
      </p>
      <p className="subtitle-description">
        {t("notification_provider_status_changed_description")}
      </p>
    </>
  );
};

export default ProviderStatusChanged;
